import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';

import { IRouteParser } from '../contracts/route/route-parser';
import { AppointmentRouteParser } from './appointment-route-parser';
import { AttachmentRouteParser } from './attachment-route-parser';
import { CareProposalRouteParser } from './careProposal-route-parser';
import { CrossTherapyRouteParser } from './cross-therapy-route-parser';
import { DirectOrderRouteParser } from './direct-order-route-parser';
import { DocumentRouteParser } from './document-route-parser';
import { InstitutionDocumentRouteParser } from './institution-document-route-parser';
import { InstitutionRouteParser } from './institution-route-parser';
import { IntegratedCareReturnDeliveryRouteParser } from './integrated-care-return-delivery-route-parser';
import { IntegratedCareRouteParser } from './integratedCare-route-parser';
import { NoteRouteParser } from './note-route-parser';
import { OrderRouteParser } from './order-route-parser';
import { PatientAppAttachmentRouteParser } from './patient-app-attachment-route-parser';
import { PatientRouteParser } from './patient-route-parser';
import { ReturnDeliveryRouteParser } from './return-delivery-route-parser';
import { SingleOrderRouteParser } from './single-order-route-parser';

export const RouteParserToken = new InjectionToken<IRouteParser>('RouteParserToken');

@NgModule({
  providers: [],
})
export class RouteParserModule {
  static forChild(): ModuleWithProviders<RouteParserModule> {
    return { ngModule: RouteParserModule, providers: [] };
  }

  static forRoot(): ModuleWithProviders<RouteParserModule> {
    return {
      ngModule: RouteParserModule,
      providers: [
        { provide: RouteParserToken, useClass: PatientRouteParser, multi: true },
        { provide: RouteParserToken, useClass: OrderRouteParser, multi: true },
        { provide: RouteParserToken, useClass: SingleOrderRouteParser, multi: true },
        { provide: RouteParserToken, useClass: DirectOrderRouteParser, multi: true },
        { provide: RouteParserToken, useClass: CrossTherapyRouteParser, multi: true },
        { provide: RouteParserToken, useClass: DocumentRouteParser, multi: true },
        { provide: RouteParserToken, useClass: AttachmentRouteParser, multi: true },
        { provide: RouteParserToken, useClass: CareProposalRouteParser, multi: true },
        { provide: RouteParserToken, useClass: IntegratedCareRouteParser, multi: true },
        { provide: RouteParserToken, useClass: NoteRouteParser, multi: true },
        { provide: RouteParserToken, useClass: ReturnDeliveryRouteParser, multi: true },
        { provide: RouteParserToken, useClass: AppointmentRouteParser, multi: true },
        { provide: RouteParserToken, useClass: InstitutionDocumentRouteParser, multi: true },
        { provide: RouteParserToken, useClass: InstitutionRouteParser, multi: true },
        { provide: RouteParserToken, useClass: PatientAppAttachmentRouteParser, multi: true },
        { provide: RouteParserToken, useClass: IntegratedCareReturnDeliveryRouteParser, multi: true },
      ],
    };
  }
}
